// store.js
import { configureStore } from '@reduxjs/toolkit';
import appReducer from './appSlice';
import clientsReducer from './clientsSlice';
import incomeReducer from './incomeSlice';
import assetReducer from './assetSlice';
import exepnseReducer from './expenseSlice';
import capitalGainReducer from './capitalGainSlice';
import authReducer from './authSlice';
import userReducer from './userSlice';
import dashboardReducer from './dashboardSlice';
import combinedReportsReducer from './combinedReportsSlice';

const store = configureStore({
  reducer: {
    app: appReducer,
    clients: clientsReducer,
    income: incomeReducer,
    asset: assetReducer,
    expenses: exepnseReducer,
    capitalGains: capitalGainReducer,
    auth: authReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    combinedReports: combinedReportsReducer,
  },
});

export default store;
